import React from "react";
import {
  ChartTypes,
  DateUnits,
  ISeries,
  ITrendDataLimit,
  Trend,
  TrendMarkerTypes,
} from "@iom/trend";
import NameHeader from "../shared/NameHeader";
import { Translation } from "react-i18next";
import "@iom/trend/build/assets/trend.css";
import * as CONSTANTS from "../../utilities/Constants";
import graphPlaceholder from "../../assets/trend.png";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import moment from "moment";
import _, { round } from "lodash";
import history from "../../utilities/History";
import DateFormatting from "../../utilities/DateFormat";
import renderBreadcrumb from "../../utilities/Breadcrumb";
import html2canvas from 'html2canvas';

import {
  Button,
  Checkbox,
  Icon,
  IconButton,
  LoadingIndicator,
  Popup,
  Spinner,
  WithPopup,
} from "@abb/abb-common-ux-react";
import {
  defaultMeasurementSettingData,
  MeasurementSetting,
} from "../../models/settings/MeasurementSettings";
import { deviation } from "d3";
import PrintHeader from "./PrintHeader";
import ReactDOM from "react-dom";

interface Item {
  title: string;
  id: number;
}
interface PropertiesProps {
  id: number;
  title: string;
}
interface Selected {
  id: any;
}
interface TableItems {
  name?: string;
  code?: string;
  minValue?: number;
  maxValue?: number;
  mean?: number;
  unit?: string;
  deviation?: number;
  alarmLow1?: string;
  alarmLow2?: string;
  alarmHigh1?: string;
  alarmHigh2?: string;
  rejectLow?: string;
  rejectHigh?: string;
  ok?: string;
  reject?: string;
  propertyId: string;
  data: any;
}
interface ChildComponentProps {
  properties?: PropertiesProps[];
  tableItems?: TableItems[];
  items?: Item[];
  isSelected?: Selected[];
  thresholdSettings: IThresholdSettings[];
}
interface IState {
  series: ISeries[];
  series1: ISeries[];
  chartType: ChartTypes;
  dateUnit: DateUnits;
  dateUnitCount: number;
  start?: Date;
  end?: Date;
  propertiesValues: any[];
  items?: Item[];
  TableItems?: TableItems[];
  //code?: string;
  minValue?: number;
  maxValue?: number;
  mean?: number;
  unit?: string;
  deviation?: number;
  // alarmLow1?: number;
  // alarmLow2?: number;
  // alarmHigh1?: number;
  // alarmHigh2?: number;
  // rejectLow?: number;
  // rejectHigh?: number;
  properties?: PropertiesProps[];
  isSelected?: Selected[];
  dataId?: Selected[];
  onRefresh?: () => void;
  settings: MeasurementSetting;
  isPrintClicked: boolean;
  loadingReport: boolean;
  pngData: any;
  isSectionVisible?: boolean;
  printLoading?: boolean;
}

class Landing extends React.Component<any, IState, ChildComponentProps> {
  private _mount: boolean;
  private _isReload: boolean;
  private _id: string;
  private _messages: string[];
  private _propertyList: any[];
  private _propertyListValues: any[];
  componentRef: any;
  printContainer: any;
  printRef: any;

  private divData: string;
  constructor(props: ChildComponentProps) {
    super(props);
    this.state = {
      chartType: "Bar",
      dateUnit: "Day",
      dateUnitCount: 10,
      start: this.props.start,
      end: this.props.end,
      propertiesValues: [],
      properties: [],
      items: [],
      series1: [],
      series: [],
      isSelected: [],
      dataId: [],
      settings: defaultMeasurementSettingData,
      isPrintClicked: false,
      loadingReport: false,
      pngData: "",
      isSectionVisible: true,
      printLoading: false,
    };
  }
  onDisplayLimitChange = (data: any) => {
    this.onDataLimitVisibilityChange(
      data.series,
      data.limit,
      !data.limit.shownInChart
    );
  };

  private getRandomColor = () => {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  componentDidUpdate(prevProps: any) {   

    const childTableHeaders = document.querySelectorAll('#child-table thead');
    childTableHeaders.forEach(header => {
      header.remove();
    });

    if(this.state.chartType == "Bar")
      {
           // Remove elements with class "circle-marker" after mount
           const elementsToRemove = document.querySelectorAll('.circle-marker');
           elementsToRemove.forEach(element => {
           element.parentNode?.removeChild(element);
           });
      }   

    if (prevProps !== this.props) {
      const dateUnitCount = moment(this.props.end).diff(
        moment(this.props.start),
        "days"
      );
      this.setState({
        start: this.props.start,
        end: this.props.end,
        dateUnitCount,
      });
      const serieslist: any[] = [];
      // Step 1: Group the data by 'name'
      const groupedData = this.props.tableItems.reduce((acc: any, currentItem: any) => {
        const { name, id } = currentItem;

        // Check if there's already an array for the current 'name', if not, create one
        if (!acc[name]) {
          acc[name] = [];
        }
        // Push the current item to the corresponding 'name' array
        acc[name].push({ name, id, currentItem });

        return acc;
      }, {});

    // Step 2: Convert groupedData object into an array of arrays (one array per group)
    let groupedArrays: any = [];
    groupedArrays = Object.values(groupedData);
    
    let finalItemByProperty: any[] = [];  
    groupedArrays.map((group: any, index: any) => {
      let yValue: number[] = [];
      const groupLength = group.length;
      const color = this.getRandomColor();
      const pointsData: any[] = []; 
      let samples = [];
      group.map((item: any, itemIndex: any) => {      

       let formattedAlarmLow1 = item.currentItem.alarmLow1 != null ? parseFloat(item.currentItem.alarmLow1) : null;
       let formattedAlarmLow2 = item.currentItem.alarmLow2 != null ? parseFloat(item.currentItem.alarmLow2) : null;
        let formattedAlarmHigh1 = item.currentItem.alarmHigh1 != null ? parseFloat(item.currentItem.alarmHigh1) : null;
        let formattedAlarmHigh2 = item.currentItem.alarmHigh2 != null ? parseFloat(item.currentItem.alarmHigh2) : null;
        let formattedMinValue = item.currentItem.minValue != null ? parseFloat(item.currentItem.minValue) : null;
        let formattedMaxValue = item.currentItem.maxValue != null ? parseFloat(item.currentItem.maxValue) : null;

        if(formattedAlarmLow1 != null) {yValue.push(formattedAlarmLow1);}
        if(formattedAlarmLow2 != null) {yValue.push(formattedAlarmLow2);}
        if(formattedAlarmHigh1 != null) {yValue.push(formattedAlarmHigh1);}
        if(formattedAlarmHigh2 != null) {yValue.push(formattedAlarmHigh2);}
        if(formattedMinValue != null) {yValue.push(formattedMinValue); }
        if(formattedMaxValue != null) {yValue.push(formattedMaxValue);}            
            
        let minYValue = 0;
        let maxYValue = 0;
        if(_.min(yValue) > 0)
          {
            minYValue = +_.min(yValue) - (_.min(yValue) / 100) * 5;            
          }
        if(_.max(yValue) > 0)
          {
            maxYValue = +_.max(yValue) + (_.max(yValue) / 100) * 5;
          }

          if(_.min(yValue) <= 0)
            {  
          minYValue = +_.min(yValue) + (_.min(yValue) / 100) * 5;
            }
          if(_.max(yValue) <= 0)
          {            
            maxYValue = +_.max(yValue) - (_.max(yValue) / 100) * 5;
          }       
        
        item.currentItem.isYAxisGiven = (itemIndex === groupLength - 1) ?  true : false;
        item.currentItem.yAxisMinValue = minYValue;        
        item.currentItem.yAxisMaxValue = maxYValue; 
        item.currentItem.fixedColor = color;
        
        samples = item.currentItem.data;
        samples?.map((s: any, sindex: any) => {
          pointsData.push({
            xValue: s.xValue,
            value: s.value,
            sampleName: s.sampleName,
            sampleId: s.sampleId,
            sampleDate: s.sampleDate
          })          
        });        
        item.currentItem.data = [];
        if(itemIndex === groupLength - 1)
          {
            item.currentItem.data = pointsData;
          }
        finalItemByProperty.push(item);         
      })         
    }) 
    
      finalItemByProperty.map((item: any, index: any) => {
        let i = item.currentItem;

        const dataLimits = [
          {
            name: "Alarm Low Limit-1",
            shownInChart: false,
            showInToolTip: true,
            value: i.alarmLow1,
            className: "custom-line-graph",
            style: {
              stroke: this.props.thresholdSettings?.find(
                (x: { name: string }) =>
                  x.name === "Alarm Low 1" || x.name === "Alarm Limit1"
              )?.colorCode,
            },
          },
          {
            name: "Alarm High Limit-1",
            shownInChart: false,
            showInToolTip: true,
            value: i.alarmHigh1,
            className: "custom-line-graph",
            style: {
              stroke: this.props.thresholdSettings?.find(
                (x: { name: string }) =>
                  x.name === "Alarm High 1" || x.name === "Alarm Limit1"
              )?.colorCode,
            },
          },
          {
            name: "Alarm Low Limit-2",
            shownInChart: false,
            showInToolTip: true,
            value: i.alarmLow2,
            className: "custom-line-graph",
            style: {
              stroke: this.props.thresholdSettings?.find(
                (x: { name: string }) =>
                  x.name === "Alarm Low 2" || x.name === "Alarm Limit2"
              )?.colorCode,
            },
          },
          {
            name: "Alarm High Limit-2",
            shownInChart: false,
            showInToolTip: true,
            value: i.alarmHigh2,
            className: "custom-line-graph",
            style: {
              stroke: this.props.thresholdSettings?.find(
                (x: { name: string }) =>
                  x.name === "Alarm High 2" || x.name === "Alarm Limit2"
              )?.colorCode,
            },
          },
        ];

        serieslist.push({
          name: i.name,
          color: i.fixedColor,
          id: index,
          markerStyle: {
            type: this.state?.chartType === "Bar" ? "None" : "Circle",
          },
          yAxis: {
            min: i.yAxisMinValue,
            max: i.yAxisMaxValue,
            decimalPlaces: i?.decimals,
          },
          isShownInChart: true,
          isYAxisGiven: i.isYAxisGiven,
          minValue: (i.minValue !== null ? +i.minValue : "--"),
          maxValue: (i.maxValue !== null ? +i.maxValue : "--"),
          mean: (i.mean !== null ? +(i.mean.toFixed(i.decimals)) : "--"),
          unit: i.unit,
          deviation: (i.deviation !== null ? +i.deviation : "--"),
          customFields: {
            "Grade/Product": i.code || "--",
            Color: i.color,
            Name: i.name,
            Unit: +i.unit || "--",
            Mean: (i.mean !== null ? +(i.mean.toFixed(i.decimals)) : "--"),
            Deviation: (i.deviation !== null ? +i.deviation : "--"),
            MinValue: (i.minValue !== null ? +i.minValue : "--"),
            MaxValue: (i.maxValue !== null ? +i.maxValue : "--"),
            AlarmLow1: (i.alarmLow1 !== null ? +i.alarmLow1 : "--"),
            AlarmHigh1: (i.alarmHigh1 !== null ? +i.alarmHigh1 : "--"),
            AlarmLow2: (i.alarmLow2 !== null ? +i.alarmLow2 : "--"),
            AlarmHigh2: (i.alarmHigh2 !== null ? +i.alarmHigh2 : "--"),
            OK:  (i.ok !== null ? +i.ok : "--"),
            Reject: (i.reject !== null ? +i.reject : "--"),
            Alarms: (i.alarmCount !== null ? +i.alarmCount : "--"),
          },
          propertyMin: +i.alarmLow1 || "--",
          points: i.data,
          dataLimits: (i.alarmLow1 !== null && i.alarmHigh1 !== null && i.alarmLow2 !== null && i.alarmHigh2 !== null) ? dataLimits : [],
        });

      });
      if (this.state.series) {
        this.setState({
          series: serieslist,
        });
        this.OrdinalSeries();
      }
    }
  }

  public OrdinalData() {
    console.log(this.state.propertiesValues);
    this.state.propertiesValues.map((i) => {
      console.log("ii", i);
    });
  }

  public OrdinalSeries() {
    var array = [...this.state.series];
    var index = array.indexOf(this.props.dataId);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ series: array });
    }
  }
  onDateRangeChange = (
    start: string | number | Date,
    end: string | number | Date,
    dateUnit: DateUnits,
    dateUnitCount: number,
    isOnZoom: boolean
  ) => {
    this.setState({
      dateUnit,
      dateUnitCount,
      start: start as Date,
      end: end as Date,
    });
  };

  onDataLimitVisibilityChange = (
    series: ISeries,
    limit: ITrendDataLimit,
    isShown: boolean
  ) => {
    let updatedValue = this.state.series.map((item) => {
      if (item.id === series.id) {
        let limits = item.dataLimits.map((line: ITrendDataLimit) => {
          if (line.name === limit.name) {
            return { ...line, shownInChart: isShown };
          } else {
            return line;
          }
        });
        return { ...item, dataLimits: limits };
      } else {
        return item;
      }
    });

    this.setState({ series: updatedValue });
  };

  onChartTypeChange = (chartType: ChartTypes) => {
    this.setState({
      chartType: chartType,
    });
    return chartType;
  };

  onSeriesChartTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item) => {
      if (item.name === series.name) {
        return { ...item, chartType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onSeriesColorChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item) => {
      if (item.name === series.name) {
        return { ...item, color: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  getMarkerStyles = (value: string, item: ISeries) => {
    let marker = item.markerStyle ? { ...item.markerStyle } : {};
    if (value === "Circle") {
      marker.type = "Circle";
      marker.fillColor = "white";
    } else if (value === "Square") {
      marker.type = "Square";
      marker.fillColor = "white";
    } else if (value === "FillCircle") {
      marker.type = "Circle";
      marker.fillColor = "SeriesColor";
    } else if (value === "FillSquare") {
      marker.type = "Square";
      marker.fillColor = "SeriesColor";
    } else {
      marker.type = "None";
    }
    return marker;
  };

  onSeriesMarkerChange = (value: TrendMarkerTypes, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item) => {
      if (item.name === series.name) {
        return {
          ...item,
          markerStyle: { ...series.markerStyle, type: value },
        } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onSeriesFillTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item) => {
      if (item.name === series.name) {
        return { ...item, fillType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onInvalidPointTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item) => {
      if (item.name === series.name) {
        return { ...item, invalidPointLineType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  generateData(
    fromDate: Date,
    toDate: Date,
    interval = 180000,
    min: number,
    max: number
  ) {
    const data = [];
    let i = 0;
    while (fromDate.getTime() < toDate.getTime()) {
      const obj = {
        xValue: new Date(fromDate),
        value:
          parseInt((Math.random() * (max - min) + min).toString()) + 0.44444444,
        status: ["Valid", "Invalid", "Good"][i % 3],
        customValue: ["Reel", "Machine", "Paper"][i % 3],
      };
      data.push(obj);
      fromDate = new Date(fromDate.getTime() + interval);
      i++;
    }
    return data;
  }

  getSampleByDate(param: any) {
    //const selectedSample = this.props.tableItems[0]?.data?.filter(
    //  (x: { xValue: any }) =>
    //    new Date(x.xValue?.toString())?.getTime() ===
    //    new Date(param?.toString())?.getTime()
    //)[0];
    //return (
    //  selectedSample?.sampleName +
    //  " (" +
    //  moment(param).format(DateFormatting.getDateTimeRegion()) +
    //  ")"
    //);
     const selectedSample = this.props.tableItems?.map((tableItem : any ) =>
       tableItem.data?.find((x: { xValue: any }) =>
         new Date(x.xValue?.toString())?.getTime() ===
         new Date(param?.toString())?.getTime()
       )
     );
     let xLabel = '';
     selectedSample.map((sample: any) => {
       if (sample !== undefined) {
         let sampleLabel = sample.sampleName +
                           " (" +
                           moment(param).format(DateFormatting.getDateTimeRegion()) +
                           ")";         
         if (!xLabel.includes(sampleLabel)) {
           if (xLabel !== '') {
             xLabel += ", ";
           }
           xLabel += sampleLabel;
         }
       }
     })
     return xLabel;
  }

  public breadcrumpClick = (link: string): void => {
    if (link) history.push(link);
  };

  private onPrintClick = () => {
    this.setState({ printLoading: true })
    let fileName = "";
    if (this.state.settings.fileNamePrefix) {
      fileName += this.state.settings.fileNamePrefix + "_";
    }
    fileName +=
      "Trend Analysis " +
      "_" +
      "Report" +
      "_" +
      moment(new Date()).format("DDMMYYYY");
    window.document.title = fileName;

    this.setState({ isPrintClicked: true, isSectionVisible: false })
    const trendComponent = this.componentRef.querySelector('.summary.pb-2');
    const parentTable = this.componentRef.querySelector('#parent-table');
    let originalParentTableStyles = {
      maxHeight: '',
      overflow: '',
    };
    if (parentTable && parentTable.querySelectorAll('tbody')) {
      const dataGrids = parentTable.querySelectorAll('tbody');
      const dataGridHeads = parentTable.querySelectorAll('thead');
      originalParentTableStyles = {
        maxHeight: parentTable.style.maxHeight,
        overflow: parentTable.style.overflow,
      };
      parentTable.style.maxHeight = 'none';
      parentTable.style.overflow = 'hidden';
      dataGrids.forEach((dataGrid: any) => {
        if (dataGrid) {
          dataGrid.style.setProperty('grid-template-columns', '1.5fr 0.7fr 2fr 1fr 1fr 1.2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 0 0', 'important');
        }
      });
      dataGridHeads.forEach((dataGridHead: any) => {
        if (dataGridHead) {
          dataGridHead.style.setProperty('grid-template-columns', '1.5fr 0.7fr 2fr 1fr 1fr 1.2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 0 0', 'important');
        }
      });
    }
    const printHeaderContainer = document.createElement('div');
    printHeaderContainer.id = 'print-header-container';
    ReactDOM.render(
      <PrintHeader
        title="Trend Analysis"
        selectedDateRange={this.props.selectedDateRange}
        selectedFromDate={this.props.start}
        selectedToDate={this.props.end}
        selectedSources={this.props.selectedSources}
        selectedGrades={this.props.selectedGrades}
        selectedProducts={this.props.selectedProducts}
        selectedSamples={this.props.selectedSamples}
      />,
      printHeaderContainer
    );

    // Insert the PrintHeader container into the trendComponent
    trendComponent.insertBefore(printHeaderContainer, trendComponent.firstChild);
    trendComponent.style.position = 'relative';
    return new Promise<void>((resolve, reject) => {
      html2canvas(trendComponent).then((canvas: any) => {
        const imgData = canvas.toDataURL('image/png');
        this.setState({ pngData: imgData, printLoading: false });
        if (parentTable) {
        parentTable.style.maxHeight = originalParentTableStyles.maxHeight;
        parentTable.style.overflow = originalParentTableStyles.overflow;
        }
        resolve();
      }).catch((error: any) => {
        this.setState({ printLoading: false })
        if (parentTable) {
        parentTable.style.maxHeight = originalParentTableStyles.maxHeight;
        parentTable.style.overflow = originalParentTableStyles.overflow;
        }
        reject(error)
      });
    });
  };

  private onAfterPrint = () => {
    return new Promise<void>((resolve, reject) => {
      window.document.title = CONSTANTS.PRODUCT_NAME;
      const trendComponent = this.componentRef.querySelector('.summary.pb-2');
      this.setState({ isPrintClicked: false, isSectionVisible: true }, () => {
        resolve()
      });
    });
  };

  setSeriesData = () => {
    const array = this.state.series;
    const updatedArray = array?.map((item) => ({
      ...item,
      dataLimits: item?.dataLimits?.map((limit) => ({
        ...limit,
        shownInChart: false,
      })),
    }));
    this.setState({ series: updatedArray });
  };

  render() {
    let groupedByGradeCodeList = this.state.series?.sort((a: any, b: any) => {
      const gradeProductA = a?.customFields?.["Grade/Product"]?.toString().toLowerCase();
      const gradeProductB = b?.customFields?.["Grade/Product"]?.toString().toLowerCase();
      return gradeProductB.localeCompare(gradeProductA);
    });

    return (
      <Translation>
        {(t) => {
          return (
            <div className="page-layout">
              {renderBreadcrumb(
                [
                  { text: t("Home"), link: "/samplenew", bolder: false },
                  { text: t(CONSTANTS.MENU_CONFIG), link: null, bolder: false },
                  { text: t(CONSTANTS.MENU_TREND), link: null, bolder: true },
                ],
                "pl-3 pb-3"
              )}
              {this.props.isLoading ? (
                <div><h6 style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center', height: "60vh" }}><Spinner color='grey' sizeClass='medium' /></h6><div></div></div>
              ) :
                (<><div className="pageheader  ml-3 pr-1 ">
                  <NameHeader
                    authKey={CONSTANTS.AUTHKEY_TRENDS}
                    data={this.props.selectedDateRange[0]?.label}
                    onRefresh={this.props.onRefresh}
                    showRefresh={true}
                    isDelete={true}
                    isMoreEnable={true}
                    onPrintClick={this.onPrintClick}
                    onAfterPrint={this.onAfterPrint}
                    showPrint={true}
                    componentRef={this.componentRef}
                    printRef={this.printRef}
                    printLoading={this.state.printLoading}
                  />
                </div>

                  <div className="summary-layout">
                    <div
                      className="report-container"
                      ref={(el) => (this.componentRef = el)}
                    >
                      <React.Fragment>
                        <div ref={(el) => (this.printRef = el)}>
                          {this.state.isPrintClicked && this.state.pngData && (
                            <div className="print-container">
                                <img src={this.state.pngData} alt="Print Preview" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                            </div>
                          )}
                        </div>
                        {this.state.isSectionVisible && (<div className="summary pb-2">
                          <div className="page-scroll dropdown-hidden">
                            {this.state.series.length ? (
                              <div className="margin-16 trend">
                                <Trend
                                  showActiveDataLimitEyeIcon={true}
                                  showSeparatorInTrendTable={true}
                                  showDataLimitTitle={true}
                                  showDataLimitConfigColumn={true}
                                  chartType={this.state.chartType}
                                  invalidPointLineType="Type1"
                                  invalidStatuses={["Invalid"]}
                                  dateUnit={this.state.dateUnit}
                                  dateUnitCount={this.state.dateUnitCount}
                                  gridLineColor="grey"
                                  gridLineWidth={0.5}
                                  showVerticalGridLines={false}
                                  showHorizontalGridLines={false}
                                  series={groupedByGradeCodeList}
                                  gridColumns={[
                                    "Grade/Product",
                                    "Color",
                                    "Name",
                                    "Unit",
                                    "Mean",
                                    "Deviation",
                                    "MinValue",
                                    "MaxValue",
                                    "AlarmLow1",
                                    "AlarmHigh1",
                                    "AlarmLow2",
                                    "AlarmHigh2",
                                    "OK",
                                    "Alarms",
                                    "Reject",
                                  ]}
                                  xAxis={{
                                    type: "DateTime",
                                    widthPerTicks: 150,
                                    start: moment(this.state.start).toDate(),
                                    end: moment(this.state.end).toDate(),
                                    tooltipFormatter: (tickValue) => {
                                      return this.getSampleByDate(tickValue);
                                    },
                                  }}
                                  onChartTypeChange={this.onChartTypeChange}
                                  onDataLimitVisibilityChange={
                                    this.onDataLimitVisibilityChange
                                  }
                                  onDateRangeChange={this.onDateRangeChange}
                                  onInvalidPointTypeChange={
                                    this.onInvalidPointTypeChange
                                  }
                                  onSeriesChartTypeChange={
                                    this.onSeriesChartTypeChange
                                  }
                                  onSeriesColorChange={this.onSeriesColorChange}
                                  onSeriesFillTypeChange={this.onSeriesFillTypeChange}
                                  onSeriesMarkerChange={this.onSeriesMarkerChange}
                                  cellDecimalPlaces={2}
                                  yAxisWidth={75}
                                  tooltipPosition="Middle"
                                  setSeriesData={this.setSeriesData}
                                  customizedMultipleYAxis={true}
                                  removeDataLimitsFromTooltip={true}
                                  isMultipleYAxis={true}
                                  showCommonXLabel={false}
                                />
                              </div>
                            ) : (
                              <div className="trend-bar-graph text-center">
                                <div className="trend-nochart">
                                  <img src={graphPlaceholder} alt="" />
                                  <div>{t(CONSTANTS.NO_TREND_DISPLAY)}</div>
                                  <div>
                                    {t(CONSTANTS.NO_TREND_SELECT_PROPERTIES)}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>)}
                      </React.Fragment>
                    </div>
                  </div></>)}
            </div>
          );
        }}
      </Translation>
    );
  }
}

export default Landing;
